import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SiteFooter } from '../ui/SiteFooter';
interface PractitionerFlowShellProps {
  /** 0 = Account, 1 = Membership, 2 = Get the app */
  currentStep: 0 | 1 | 2;
  children: React.ReactNode;
}
const steps = ['Create account', 'Choose membership', 'Open the app'];
export function PractitionerFlowShell({
  currentStep,
  children
}: PractitionerFlowShellProps) {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal flex flex-col" data-id="element-412" data-mp="3vljbuyhks8s5">
      {/* Navigation — matches the site nav */}
      <nav className="sticky top-0 left-0 right-0 z-50 w-full px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-413" data-mp="3lw82rbuov449">
        <a href="/" aria-label="Fem Entity home" data-id="element-414" data-mp="i7oe849dp829">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-415" data-mp="i9961m4b6cwf" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-416" data-mp="2bn4pnfgle8me">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-417" data-mp="2fmdk6mjgiaj0">
            Home
          </a>
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-418" data-mp="21v8ti9y2gskt">
            Download the App
          </a>
          <a href="/practitioners" className="text-purple-700 font-semibold" data-id="element-419" data-mp="26t0h4rrohsj7">
            Practitioners
          </a>
        </div>
      </nav>

      <main className="flex-1 pt-10 md:pt-14 pb-24" data-id="element-420" data-mp="1wxgruo7mds3f">
        <ol aria-label="Signup progress" className="max-w-xl mx-auto px-6 flex items-center justify-center gap-2 sm:gap-3" data-id="element-421" data-mp="1wuugselisugg">
          {steps.map((label, index) => {
          const done = index < currentStep;
          const active = index === currentStep;
          return <li key={label} aria-current={active ? 'step' : undefined} className="flex items-center gap-2 sm:gap-3" data-id="element-422" data-mp="3d9ch8ye29khf" data-mpi={index}>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${done ? 'bg-purple-700 text-white' : active ? 'border-2 border-purple-700 text-purple-800 bg-white' : 'border border-charcoal/20 text-charcoal/45 bg-white'}`} data-id="element-423" data-mp="3ftimraibpj03">
                  {done ? <CheckIcon aria-hidden="true" className="w-3.5 h-3.5" data-id="element-424" data-mp="3uk9i2sj4j07y" /> : index + 1}
                </span>
                <span className={`hidden sm:inline whitespace-nowrap text-sm ${active ? 'font-semibold text-charcoal' : 'text-charcoal/55'}`} data-id="element-425" data-mp="3psrgq3d6uxmg">
                  {label}
                  {done && <span className="sr-only" data-id="element-426" data-mp="hdzmyq98jx2y"> (complete)</span>}
                </span>
                {index < steps.length - 1 && <span aria-hidden="true" className="h-px w-6 sm:w-10 bg-charcoal/15" data-id="element-427" data-mp="opxdyyhsrb4w" />}
              </li>;
        })}
        </ol>

        <div className="mt-12 md:mt-16" data-id="element-428" data-mp="ynblu9pnmrll">{children}</div>
      </main>

      <SiteFooter currentPath="/practitioners" data-id="element-429" data-mp="ym0ho8sarhty" />
    </div>;
}